var React = require('react');

function Philips (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0","d":"M14.2,9.6c0,3.2-1.5,5.4-5.5,5.4H7.6V4.8c0.4,0,0.9,0,1.2,0C12.5,4.7,14.2,6.5,14.2,9.6z M10.2,19.5\n\tc7,0,11.4-3.6,11.4-10c0-7-4.7-9.5-12.5-9.5c-3,0-6.6,0.2-9.2,0.5v24.8h7.5v-5.9L10.2,19.5L10.2,19.5z M110.9,9.6\n\tc0,3.2-1.5,5.4-5.5,5.4h-1.2V4.8c0.4,0,0.9,0,1.2,0C109.2,4.7,110.9,6.5,110.9,9.6z M106.9,19.5c7,0,11.4-3.6,11.4-10\n\tc0-7-4.7-9.5-12.5-9.5c-3,0-6.6,0.2-9.2,0.5v24.8h7.5v-5.9L106.9,19.5L106.9,19.5z M128.1,6.9c0-1.3,1.3-2,3.5-2\n\tc2.4,0,4.9,0.5,6.7,1.2l-0.6-5.4c-2-0.4-3.7-0.7-6.9-0.7c-6.1,0-10.2,2.4-10.2,7.5c0,8.7,11.7,7,11.7,11c0,1.6-1.1,2.4-3.9,2.4\n\tc-2.5,0-6.3-0.8-8.5-2l0.8,5.7c2.3,0.8,5.4,1.2,7.8,1.2c6.3,0,11.4-2.1,11.4-8.3C140,9.3,128.1,10.9,128.1,6.9z M91.1,0.6h-7.5v24.8\n\th7.5V0.6z M60.6,0.6h-7.5v24.8h7.5V0.6z M73.7,20.4V0.6h-7.5v24.8h13.6l1.1-5L73.7,20.4L73.7,20.4z M47.5,0.6H40v9.9h-7.8V0.6h-7.5\n\tv24.8h7.5v-9.8H40v9.8h7.5V0.6z","key":1})]);
}

Philips.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"170px","height":"26px","viewBox":"0 0 170 26","style":{"enableBackground":"new 0 0 170 26"},"xmlSpace":"preserve"};

module.exports = Philips;

Philips.default = Philips;



//////////////////
// WEBPACK FOOTER
// ./src/assets/work-logos/philips.svg
// module id = 932
// module chunks = 168707334958949